import UnitDetailContent from './UnitDetailContent';

export default UnitDetailContent;
